<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.62207 14.4569C2.035 18.2649 5.70043 20.9787 10.0001 20.9787C14.2997 20.9787 17.9652 18.2649 19.3781 14.4569L10.0001 13.5874L0.62207 14.4569Z"
            fill="#FFDA44"
        />
        <path
            d="M10.0001 0.978516C5.70043 0.978516 2.035 3.69227 0.62207 7.50027L10.0001 8.3698L19.3781 7.50023C17.9652 3.69227 14.2997 0.978516 10.0001 0.978516Z"
            fill="black"
        />
        <path
            d="M0.621992 7.50049C0.220039 8.58381 0 9.75553 0 10.9787C0 12.2019 0.220039 13.3737 0.621992 14.457H19.378C19.78 13.3737 20 12.2019 20 10.9787C20 9.75553 19.78 8.58381 19.378 7.50049H0.621992Z"
            fill="#D80027"
        />
    </svg>
</template>